import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Chart, Ring } from './PercentageComplete.styles';

interface Props {
  percentageCompleted: number;
}

export const PercentageComplete = ({ percentageCompleted }: Props) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      css={({ theme }) => ({ gridGap: theme.space['12'] })}
      ml={-24}
    >
      <Chart>
        <Ring progress={percentageCompleted} />
      </Chart>

      <Text fontSize="small">{percentageCompleted}% Complete</Text>
    </Box>
  );
};
